
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Thanetopunecab() {



    const cardData =
    {
        keyword: 'Thane to Pune Cab',
        heading: 'Meghana Cab : Thane to Pune Cab',
        headingDescription: 'Meghana Cab offers Thane to Pune Cab services, providing a dependable, comfortable, and hassle-free ride between the vibrant city of Thane and the cultural capital of Maharashtra, Pune. Whether it is a corporate trip, weekend getaway, or family travel, our fleet of well-maintained cabs—ranging from hatchbacks and sedans to SUVs and tempo travellers—ensures a safe and enjoyable journey. Benefit from transparent pricing, on-time pickups, and courteous drivers backed by 24/7 customer support. Book your Thane to Pune Cab with Meghana Cab for a smooth intercity travel experience focused on comfort, punctuality, and peace of mind.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
   {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
  {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Thane to Pune Taxi Booking",
    "description": "Easily book your taxi from Thane to Pune with our hassle-free service. Whether for business or leisure, we provide well-maintained vehicles and professional drivers ensuring a safe and comfortable journey. Enjoy prompt pickups, flexible scheduling, and transparent pricing tailored to your travel needs."
  },
  {
    "name": "One Way Cab Thane to Pune",
    "description": "Travel smoothly with our reliable one-way cab service from Thane to Pune. Perfect for quick trips or single-direction travel, our cabs are clean, air-conditioned, and driven by experienced chauffeurs who prioritize your comfort and punctuality."
  },
  {
    "name": "Round Trip Cab Thane to Pune",
    "description": "Plan your round trip between Thane and Pune with confidence. Our flexible packages accommodate day trips or multi-day journeys, featuring courteous drivers, modern vehicles, and door-to-door service that ensures a seamless travel experience throughout."
  },
  {
    "name": "Cab Hire from Thane to Pune",
    "description": "Hire a cab from Thane to Pune for any occasion with ease. Whether it’s a family outing, business meeting, or personal travel, we provide a variety of vehicle options, professional drivers, and dedicated customer support to make your ride enjoyable and stress-free."
  },
  {
    "name": "Online Cab Booking Thane to Pune",
    "description": "Book your cab online from Thane to Pune through our secure and user-friendly platform. Select your vehicle, pick your timing, and confirm your ride instantly. Experience the convenience of digital booking paired with dependable service and competitive pricing."
  },
  {
    "name": "Budget Taxi Thane to Pune",
    "description": "Travel economically with our budget taxi service from Thane to Pune. We offer safe and clean vehicles at affordable rates, ideal for solo travelers, students, and anyone seeking value without compromising on comfort or safety."
  },
  {
    "name": "AC Sedan Cab Thane to Pune",
    "description": "Enjoy a cool and comfortable ride in our air-conditioned sedan cabs from Thane to Pune. Perfect for business travelers and small families, our sedans provide a smooth journey with modern amenities and professional drivers dedicated to your convenience."
  },
  {
    "name": "SUV Rental Thane to Pune",
    "description": "Travel in spacious style with our SUV rental service from Thane to Pune. Ideal for larger groups or families with extra luggage, our SUVs come equipped with all comforts, ensuring a relaxing and enjoyable trip on every journey."
  },
  {
    "name": "24/7 Cab Service Thane to Pune",
    "description": "Our round-the-clock cab service from Thane to Pune guarantees you reliable transportation any time of the day or night. Whether early morning or late night, count on us for punctual pickups, professional drivers, and well-maintained vehicles."
  },
  {
    "name": "Book Private Taxi Thane to Pune",
    "description": "Experience personalized travel with our private taxi service from Thane to Pune. Enjoy exclusive use of the vehicle, flexible schedules, and professional chauffeurs who make your journey comfortable, safe, and tailored to your specific needs."
  },
  {
    "name": "Corporate Travel Thane to Pune Cab",
    "description": "Make your business commute seamless with our corporate travel cabs from Thane to Pune. We offer premium vehicles, discreet and punctual chauffeurs, and flexible packages designed to meet the demands of busy professionals."
  },
  {
    "name": "Fast Cab Thane to Pune",
    "description": "Need a speedy ride? Our fast cab service from Thane to Pune ensures quick and efficient travel with expert drivers who know the best routes to get you there on time, every time, without compromising safety or comfort."
  },
  {
    "name": "Affordable Fare Thane to Pune Cab",
    "description": "Get the best value for your money with our affordable fare cabs from Thane to Pune. We combine competitive pricing with excellent service standards, making your travel budget-friendly without any compromise on quality."
  },
  {
    "name": "Premium Cab Hire Thane to Pune",
    "description": "Travel in luxury with our premium cab hire service from Thane to Pune. Choose from top-end sedans and SUVs equipped with the latest amenities and driven by courteous, professional chauffeurs dedicated to providing a first-class travel experience."
  },
  {
    "name": "Family Cab Thane to Pune Trip",
    "description": "Make your family trip from Thane to Pune comfortable and memorable with our family-friendly cabs. Spacious vehicles, safety features, and experienced drivers ensure a relaxed and enjoyable journey for all family members, from kids to seniors."
  }
],
"tableData": [
  ["Thane to Pune Taxi Booking", "One Way Cab Thane to Pune"],
  ["Round Trip Cab Thane to Pune", "Cab Hire from Thane to Pune"],
  ["Online Cab Booking Thane to Pune", "Budget Taxi Thane to Pune"],
  ["AC Sedan Cab Thane to Pune", "SUV Rental Thane to Pune"],
  ["24/7 Cab Service Thane to Pune", "Book Private Taxi Thane to Pune"],
  ["Corporate Travel Thane to Pune Cab", "Fast Cab Thane to Pune"],
  ["Affordable Fare Thane to Pune Cab", "Premium Cab Hire Thane to Pune"],
  ["Family Cab Thane to Pune Trip", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Reliable Thane to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab offers trustworthy and comfortable cab services from Thane to Pune, ensuring a smooth journey whether you’re traveling for business or leisure. Our well-maintained, air-conditioned vehicles provide a relaxing environment for the roughly 150 km drive along the Mumbai-Pune Expressway."
    },
    {
        "WhyChooseheading": "Flexible and Customized Travel Packages",
        "WhyChoosedescription": "We offer a range of travel options including one-way trips, round-trip packages, and multi-day tours tailored to your preferences. Our team helps you plan your itinerary with convenient stops, sightseeing opportunities, or quick transfers to make your journey hassle-free and enjoyable."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Thane to Pune cab fares include fuel, tolls, driver allowances, and taxes. We provide clear, upfront pricing so you can select the vehicle and package that best suit your budget without any surprise costs during or after the trip."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Long Distance Travel",
        "WhyChoosedescription": "Travel comfortably in sanitized, air-conditioned sedans, SUVs, or tempo travellers based on your group size. Our vehicles are regularly serviced and cleaned to ensure a safe and pleasant journey, whether you’re traveling solo or with family and friends."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our professional drivers are knowledgeable about the fastest and safest routes between Thane and Pune, including alternate paths to avoid traffic. They prioritize your safety, punctuality, and convenience throughout the journey."
    },
    {
        "WhyChooseheading": "Customizable Trip Schedules and Stopovers",
        "WhyChoosedescription": "Choose flexible departure times and customize your journey with planned stops for meals, sightseeing, or rest breaks. Whether you want a quick transfer or a relaxed trip with overnight stays, we tailor the experience to your needs."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Customer Assistance",
        "WhyChoosedescription": "Our booking services are available round-the-clock to accommodate your travel plans. Our dedicated customer care team is always ready to assist with reservations, itinerary changes, or any special requests to ensure a smooth trip."
    },
    {
        "WhyChooseheading": "Perfect for Families, Corporate Travelers, and Groups",
        "WhyChoosedescription": "Whether traveling for work or leisure, our Thane to Pune cab service caters to families, business professionals, and groups. We emphasize comfort, timely service, and a safe travel experience for all passengers."
    }
]


























    }

const faqData = [
    {
        question: "How can I book a cab from Thane to Pune with Meghana Cab?",
        answer: "You can book your Thane to Pune cab by calling Meghana Cab at +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "What vehicle options are available for the Thane to Pune route?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for individuals, families, or groups."
    },
    {
        question: "Are Meghana Cab drivers experienced with the Thane to Pune route?",
        answer: "Yes, our drivers are knowledgeable about the best routes from Thane to Pune for a smooth journey."
    },
    {
        question: "Is one-way cab service available from Thane to Pune?",
        answer: "Yes, both one-way and round-trip cab services are available for your convenience."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Our fares cover fuel, tolls, and driver charges. Additional charges may apply for parking or extended waiting."
    },
    {
        question: "Are the vehicles sanitized before the trip?",
        answer: "Yes, all vehicles are thoroughly sanitized before every trip to ensure passenger safety."
    },
    {
        question: "Is the Thane to Pune cab service available 24/7?",
        answer: "Yes, Meghana Cab operates 24/7 to match your travel needs."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, halts can be arranged upon request. Please inform us while booking."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab to book a Thane to Pune cab?",
        answer: "Call us anytime at +91 9075462128 to book your cab or for any assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Prakash Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Thane to Pune trip with Meghana Cab was comfortable and timely. The driver was very professional.”',
    },
    {
        name: 'Ms. Kavya Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service and clean vehicle. Meghana Cab made our travel from Thane to Pune hassle-free.”',
    },
];











































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const thaneToPuneCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Thane to Pune Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/thane-to-pune-cab.jpg",
  "description": "Book affordable and reliable taxi service from Thane to Pune with Meghana Cabs. One way, round trip, AC sedan, SUV options, and 24/7 service available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Thane to Pune Taxi Booking",
    "One Way Cab Thane to Pune",
    "Round Trip Cab Thane to Pune",
    "Cab Hire from Thane to Pune",
    "Online Cab Booking Thane to Pune",
    "Budget Taxi Thane to Pune",
    "AC Sedan Cab Thane to Pune",
    "SUV Rental Thane to Pune",
    "24/7 Cab Service Thane to Pune",
    "Book Private Taxi Thane to Pune",
    "Corporate Travel Thane to Pune Cab",
    "Fast Cab Thane to Pune",
    "Affordable Fare Thane to Pune Cab",
    "Premium Cab Hire Thane to Pune",
    "Family Cab Thane to Pune Trip"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Thane"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Thane to Pune Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab Thane to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Thane to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AC Sedan Cab Thane to Pune"
        }
      }
    ]
  }
};





    return (
        <div>


<Helmet>
  <title>Thane to Pune Cab | Reliable Taxi Service</title>
  <meta
    name="description"
    content="Book affordable and reliable taxi service from Thane to Pune with Meghana Cabs. One way, round trip, AC sedan, SUV options, and 24/7 service available."
  />
  <meta
    name="keywords"
    content="Thane to Pune Taxi Booking, One Way Cab Thane to Pune, Round Trip Cab Thane to Pune, Cab Hire from Thane to Pune, Online Cab Booking Thane to Pune, Budget Taxi Thane to Pune, AC Sedan Cab Thane to Pune, SUV Rental Thane to Pune, 24/7 Cab Service Thane to Pune, Book Private Taxi Thane to Pune, Corporate Travel Thane to Pune Cab, Fast Cab Thane to Pune, Affordable Fare Thane to Pune Cab, Premium Cab Hire Thane to Pune, Family Cab Thane to Pune Trip"
  />
  <script type="application/ld+json">
    {JSON.stringify(thaneToPuneCabSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Thanetopunecab;